module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-VSCO.d54026ff.png";